import { AfterViewInit,Component,ElementRef,HostListener,Input,OnChanges,SimpleChanges,ViewChild,forwardRef } from '@angular/core';
import { ControlValueAccessor,FormControl,FormGroup,NG_VALUE_ACCESSOR,Validators } from '@angular/forms';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { dom } from '@lib/dom';
import { path } from '@lib/path-browser';

@Component({
	selector: 'file-upload-base',
	templateUrl: './file-upload-base.component.html',
	styleUrls: ['./file-upload-base.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(()=>FileUploadBase),
			multi: true
		},
	]
})
export class FileUploadBase implements AfterViewInit, ControlValueAccessor, OnChanges{
	private static nextIdIndex=1;

	@Input() disabled:boolean=false;
	@Input() accept:string;
	@Input() labelText:string;
	@Input() parentFormGroup:FormGroup;
	@Input() fieldName:string;
	public fileUploadControl=new FormControl('', [Validators.required]);

	@ViewChild('inputFile') inputFile:ElementRef<HTMLInputElement>;

	public domId=`file-upload-file-input-${FileUploadBase.nextIdIndex++}`;

	public status:'bad-type'=null;
	public hasFileOver=false;
	public acceptsText='\xa0';//non-breaking spacing
	public acceptedExtentions:string[]=null;
	private statusReverseTimeout=0;

	public constructor(
		private readonly dialog:DialogService
	){
	}

	ngOnChanges(changes:SimpleChanges){
		if(changes['accept']){
			this.acceptsText='\xa0';//non-breaking spacing
			this.acceptedExtentions=null;
			if(this.accept){
				this.acceptedExtentions=this.accept.split(',').map(v=>v.trim());
				this.acceptsText=`(accepts ${this.acceptedExtentions.join(', ')})`;
				this.acceptedExtentions=this.acceptedExtentions.map(v=>v.toLowerCase());
			}
		}
	}

	ngAfterViewInit(){
		if (this.parentFormGroup){
			this.parentFormGroup.addControl(this.fieldName, this.fileUploadControl);
		}
	}

	protected filterFiles(files:File[]){
		if(!this.acceptedExtentions || this.acceptedExtentions.includes('.*'))
			return files;
		return files.filter(file=>this.acceptedExtentions.includes(path.extname(file.name).toLowerCase()));
	}

	protected acceptsFile(file:File){
		if(!this.acceptedExtentions || this.acceptedExtentions.includes('.*'))
			return true;
		return this.acceptedExtentions.some(e=>{
			if(e.includes('*')){
				const s=e.replaceAll('*','').replace('.','').toLowerCase();
				return path.extname(file.name).toLowerCase().startsWith(s) || path.extname(file.name).toLowerCase().endsWith(s);
			}
			return e.includes(path.extname(file.name).toLowerCase());
		})
	}

	public filesSelected(files:File[]){
	}

	protected clearTemporyStatus(){
		if(this.statusReverseTimeout){
			if(this.status=='bad-type')
				this.status=null;
			clearTimeout(this.statusReverseTimeout);
			this.statusReverseTimeout=0;
		}
	}

	protected setTemporyStatus(status:'bad-type'){
		this.status=status;
		if(this.statusReverseTimeout)
			clearTimeout(this.statusReverseTimeout);
		this.statusReverseTimeout=window.setTimeout(()=>{
			this.status=null;
			this.statusReverseTimeout=0;
		},3000);
	}

	@HostListener('dragenter',['$event']) onDragOver(event:DragEvent){
		event.preventDefault();
		event.stopPropagation();
		this.hasFileOver=true;
		this.clearTemporyStatus();
	}

	@HostListener('dragleave',['$event']) onDragLeave(event:DragEvent){
		event.preventDefault();
		event.stopPropagation();
		this.hasFileOver=false;
	}

	@HostListener('drop',['$event']) onDrop(event:DragEvent){
		event.preventDefault();
		event.stopPropagation();
		this.dialog.await(dom.file.dataTransferItemsToFilesRecursive(event.dataTransfer.items))
			.then(files=>this.filesSelected(files));
	}

	@HostListener('document:drop',['$event']) onDocumentDrop(event:DragEvent){
		//make sure you don't miss the target and open up the file in the browser
		event.preventDefault();
		event.stopPropagation();
	}

	public fileBrowsed(event:Event){
		event.preventDefault();
		event.stopPropagation();
		this.filesSelected(Array.from(this.inputFile.nativeElement.files));
	}

	public writeValue(value:any){
	}

	public registerOnChange(fn:(_:any)=>{}){
	}

	public registerOnTouched(){}

}
